export const OpinometroActionTypes = {
  API_RESPONSE_SUCCESS: '@@opinometro/API_RESPONSE_SUCCESS',
  API_RESPONSE_ERROR: '@@opinometro/API_RESPONSE_ERROR',

  GET_OPINOMETRO: '@@opinometro/GET_OPINOMETRO',
  LIST_OPINOMETROS: '@@opinometro/LIST_OPINOMETROS',
  ADD_OPINOMETRO: '@@opinometro/ADD_OPINOMETRO',
  DUPLICATE_OPINOMETRO: '@@opinometro/DUPLICATE_OPINOMETRO',
  UPDATE_OPINOMETRO: '@@opinometro/UPDATE_OPINOMETRO',
  DELETE_OPINOMETRO: '@@opinometro/DELETE_OPINOMETRO',

  RESET: '@@opinometro/RESET'
}
